import InvoiceDetail from './InvoiceDetail'

export default InvoiceDetail
